import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController, ToastController, LoadingController } from 'ionic-angular';
import { UsuarioDAO } from '../../daos/usuario-dao';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Usuario } from '../../entities/usuario';
import { MenuComponent } from '../../components/menu/menu';
import { Empresa } from '../../entities/empresa';
import { CadastroUsuarioPage } from '../../pages/cadastro-usuario/cadastro-usuario';
import { AppModule } from '../../app/app.module';
import { EnviarEmailSenhaPage } from '../enviar-email-senha/enviar-email-senha';

@Component({
    selector: 'page-login',
    templateUrl: './login.html'
})
export class LoginPage {
    public formLogin: FormGroup;
    public usuario: Usuario = new Usuario();
    mostrarsenha: boolean = false;

    public empresaLogada : Empresa = new Empresa();
    constructor(
        private _formBuilder: FormBuilder,
        private _navCtrl: NavController,
        private _toastCtrl: ToastController,
        private _loadingCtrl: LoadingController,
        private _usuarioDao: UsuarioDAO,
        private _storage: Storage
    ) {
        this.empresaLogada =  AppModule.getEmpresa();
        this.manterLogin();
        this.formLogin = this._formBuilder.group({
            Usuario: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            Senha: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            MantenhaConectado: [false]
        });         
        
    }

    alternarVisibilidadeSenha() {
        this.mostrarsenha = !this.mostrarsenha;
    }

    manterLogin(): void {
        this._storage.get('manter').then(manter => {
            if (manter) {
                this._storage.get('usuario').then(usuario => {  
                    if (usuario !== null){
                        this.usuario = usuario;   
                        this._navCtrl.setRoot(MenuComponent, { usuario: usuario });
                    }  
                });
            } 
        });
    }

    navegarParaCadastro() {
        this._navCtrl.push(CadastroUsuarioPage);
    }
    navegarParaRedefinirSenha() {
        this._navCtrl.push(EnviarEmailSenhaPage);
    }

    public doLogin(): void {
        if (this.formLogin.invalid) {
            this._toastCtrl.create({
                message: 'O formulário está invalido. Favor Verifique!',
                duration: 3000
            }).present();

            return;
        }
        
        this.usuario.CpfUsuario = this.usuario.CpfUsuario.toLowerCase();
        this.usuario.Senha = this.usuario.Senha.toLowerCase();
        this.usuario.Empresa = this.empresaLogada;        

        let load = this._loadingCtrl.create({ content: 'Autenticando o usuário...' });
        load.present();

        this._usuarioDao.login(this.usuario).then((usuario) => {
            if (usuario.IdUsuario)
                this._navCtrl.setRoot(MenuComponent, { usuario: usuario }).then(() => {
                    load.dismiss();
                    this._storage.set('manter', (this.formLogin.controls['MantenhaConectado'].value));
                    if (this.formLogin.controls['MantenhaConectado'].value)
                        this._storage.set('usuario', usuario);
                });
            else
                load.dismiss().then(() => {
                    this._toastCtrl.create({
                        message: 'Usuário inválido!',
                        duration: 3000
                    }).present();
                });
        }).catch((erro) => {
            console.error(erro);
            load.dismiss();
            this._toastCtrl.create({
                message: 'Não foi possível entrar, tente novamente!',
                duration: 3000
            }).present();
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts